import { mapMutations } from "vuex";

export const hasSnackbarAccess = {
  methods: {
    ...mapMutations("snackbar", ["showSnackbar"]),
  },
};
